function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon_aivory_logo",
  transform: "translate(-324.518 -237.136)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_742",
  d: "M464 248.136a1.354 1.354 0 0 1-.628-.154 1.435 1.435 0 0 1-.706-.842 1.491 1.491 0 0 1 .076-1.111l3.911-8.088a1.4 1.4 0 0 1 1.26-.805 1.356 1.356 0 0 1 .628.154 1.435 1.435 0 0 1 .706.842 1.491 1.491 0 0 1-.077 1.111l-3.911 8.088a1.4 1.4 0 0 1-1.26.805",
  className: "cls-1",
  transform: "translate(-120.801)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_743",
  d: "M436.654 248.136a1.4 1.4 0 0 1-1.26-.805l-3.911-8.088a1.491 1.491 0 0 1-.077-1.111 1.433 1.433 0 0 1 .706-.842 1.351 1.351 0 0 1 .628-.154 1.4 1.4 0 0 1 1.26.805l3.911 8.088a1.491 1.491 0 0 1 .076 1.111 1.433 1.433 0 0 1-.706.842 1.349 1.349 0 0 1-.628.154",
  className: "cls-1",
  transform: "translate(-93.453)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_744",
  d: "M325.926 248.136a1.355 1.355 0 0 1-.629-.154 1.435 1.435 0 0 1-.706-.842 1.491 1.491 0 0 1 .076-1.111l3.911-8.088a1.4 1.4 0 0 1 1.26-.805 1.356 1.356 0 0 1 .628.154 1.435 1.435 0 0 1 .706.842 1.491 1.491 0 0 1-.077 1.111l-3.911 8.088a1.4 1.4 0 0 1-1.26.805",
  className: "cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_745",
  d: "M361.1 248.136a1.4 1.4 0 0 1-1.26-.805l-3.911-8.088a1.491 1.491 0 0 1-.077-1.111 1.433 1.433 0 0 1 .706-.842 1.351 1.351 0 0 1 .628-.154 1.4 1.4 0 0 1 1.26.805l3.911 8.088a1.491 1.491 0 0 1 .076 1.111 1.433 1.433 0 0 1-.706.842 1.349 1.349 0 0 1-.628.154",
  className: "cls-1",
  transform: "translate(-27.347)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_746",
  d: "M398.867 248.136a1.4 1.4 0 0 1-1.26-.805l-3.911-8.088a1.492 1.492 0 0 1-.077-1.111 1.433 1.433 0 0 1 .706-.842 1.351 1.351 0 0 1 .628-.154 1.4 1.4 0 0 1 1.26.805l3.911 8.088a1.492 1.492 0 0 1 .077 1.111 1.433 1.433 0 0 1-.706.842 1.348 1.348 0 0 1-.628.154",
  className: "cls-1",
  transform: "translate(-60.394)"
}));

function SvgIconAivoryLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 11,
    viewBox: "0 0 24 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAivoryLogo);
export default __webpack_public_path__ + "static/media/icon-aivory-logo.2ad11e54.svg";
export { ForwardRef as ReactComponent };